export const DEFAULT_PROMO_TEXT = 'Ücretsiz kargo 500₺ ve üzeri siparişlerde!';

export const parsePromoLines = (raw) => {
  if (raw === '') return [];
  if (!raw || typeof raw !== 'string') return [DEFAULT_PROMO_TEXT];

  const lines = raw
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  return lines.length > 0 ? lines : [DEFAULT_PROMO_TEXT];
};

/** Metin uzunluğuna göre okuma süresi (ms) */
export const getPromoReadingMs = (text, reducedMotion = false) => {
  if (reducedMotion) return 8000;

  const MIN = 3500;
  const MAX = 10000;
  const PER_CHAR = 55;

  return Math.min(MAX, Math.max(MIN, text.length * PER_CHAR));
};
